import script from "./productDatails.vue?vue&type=script&lang=ts&setup=true"
export * from "./productDatails.vue?vue&type=script&lang=ts&setup=true"

import "./productDatails.vue?vue&type=style&index=0&id=63c80de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c80de8"]])

export default __exports__